import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import _get from 'lodash/get'

import Link from '@components/Link'
import LazyLoad from '@components/common/Lazyload'

import { playStoreBadge, appStoreBadge } from '@global/imageUrl'
import s from './footer.css'
class Footer extends Component {
  handleLink = link => {
    window.open(link, '_blank')
  }

  render() {
    const year = new Date().getFullYear()
    const { store_url, ios_store_url } = this.props.configParams.data ? this.props.configParams.data : ''
    const footerData = _get(this.props.configParams, 'quickAccess.footer', null)
    const footerEnabled = footerData && this.props.configParams.data.social_media_url && true
    const { categories, menu, info } = footerEnabled && footerData ? footerData : []
    const { facebook, twitter, instagram } =
      footerEnabled && this.props.configParams.data.social_media_url
        ? this.props.configParams.data.social_media_url
        : ''

    return (
      <>
        {footerEnabled && (
          <div className={s.divider}>
            <div className={s.footer__container}>
              <div className={s.categories__container}>
                {categories.map((category, idx) => {
                  return (
                    <div className={s.footer__item} key={idx}>
                      <Link to={category.url}>{category.text}</Link>
                    </div>
                  )
                })}
              </div>
              <div className={s.menu__container}>
                {menu.map((menuItem, idx) => {
                  return (
                    <div className={s.footer__item} key={idx}>
                      <Link to={menuItem.url}>{menuItem.text}</Link>
                    </div>
                  )
                })}
              </div>
              <div className={s.info__container}>
                {info.map((infoItem, idx) => {
                  return (
                    <div className={s.footer__item} key={idx}>
                      <Link to={infoItem.url}>{infoItem.text}</Link>
                    </div>
                  )
                })}
              </div>
              <div className={s.store__n__social}>
                <div className={s.social__container}>
                  {facebook && (
                    <div className={`${s.social__icon} ${s.facebook}`} onClick={() => this.handleLink(facebook)} />
                  )}
                  {twitter && (
                    <div className={`${s.social__icon} ${s.twitter}`} onClick={() => this.handleLink(twitter)} />
                  )}
                  {instagram && (
                    <div className={`${s.social__icon} ${s.instagram}`} onClick={() => this.handleLink(instagram)} />
                  )}
                </div>
                <div className={s.store__container}>
                  <div className={s.store__item}>
                    <img src={playStoreBadge} onClick={() => this.handleLink(store_url)} />
                  </div>
                  <div className={s.store__item}>
                    <img src={appStoreBadge} onClick={() => this.handleLink(ios_store_url)} />
                  </div>
                </div>
                <div className={s.copyright__year}>
                  &copy; <span>{year}</span> Mola TV
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return { ...state }
}

export default compose(withStyles(s), connect(mapStateToProps, null))(Footer)
